import { Alert, Button, Stack } from "@mui/material";
import React from "react";
import { useGlobalState } from "../components/globalState";
import { useAuth } from "../context/AuthContext";
import { SnoozeButton, useBannerSnoozed } from "./banner-snooze";

export const ImpersonationBanner: React.FC = () => {
	const { isImpersonating, stopImpersonating } = useAuth();
	const { currentUser } = useGlobalState();
	// Per impersonated user: switching to someone else shows the banner again.
	const bannerKey = `impersonation:${currentUser?.id}`;
	const snoozed = useBannerSnoozed(bannerKey);

	if (!isImpersonating || snoozed) return null;

	return (
		<Alert
			severity="warning"
			data-component="impersonation-banner"
			action={
				<Stack
					direction="row"
					spacing={1}
					data-component="impersonation-actions"
				>
					<Button
						color="inherit"
						size="small"
						onClick={stopImpersonating}
						data-component="exit-impersonation-button"
					>
						Exit Impersonation
					</Button>
					<SnoozeButton bannerKey={bannerKey} />
				</Stack>
			}
		>
			You are currently impersonating {currentUser?.username}
		</Alert>
	);
};
